import {ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {surface3dIcons} from './surface3d-icons';

@Component({
    selector: 's3design-icon',
    template: `
        <mat-icon><ng-content></ng-content></mat-icon>
    `,
    styles: ['.surfaceIcon svg{width: 100%; height: 100%}'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Surface3dIconsComponent {

    @HostBinding('class.surfaceIcon') true;

    constructor(private element: ElementRef) {
    }

    @Input()
    set name(iconName: string) {
        this.element.nativeElement.innerHTML = surface3dIcons[iconName] || null;
    }

}
